var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubstract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 262",
    y: 9.5,
    width: 2,
    height: 16,
    rx: 1,
    transform: "rotate(-90 0 9.5)",
    fill: "#60666C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 263",
    x: 16,
    y: 7.5,
    width: 2,
    height: 16,
    rx: 1,
    transform: "rotate(90 16 7.5)",
    fill: "#60666C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstract);
export default __webpack_public_path__ + "static/media/substract.bc6a8670144cc3c3ddce0646138cae9a.svg";
export { ForwardRef as ReactComponent };